"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShippingDetailsSchema = void 0;
const getShippingDetailsSchema = (isFreeShipping = true, shouldSpecifiyDeliveryTime = true) => {
    if (!isFreeShipping) {
        return undefined;
    }
    if (shouldSpecifiyDeliveryTime) {
        return {
            shippingDetails: {
                '@type': 'OfferShippingDetails',
                shippingRate: {
                    '@type': 'MonetaryAmount',
                    value: 0,
                    currency: 'USD',
                },
                shippingDestination: {
                    '@type': 'DefinedRegion',
                    addressCountry: 'US',
                },
                deliveryTime: {
                    '@type': 'ShippingDeliveryTime',
                    handlingTime: {
                        '@type': 'QuantitativeValue',
                        minValue: 0,
                        maxValue: 0,
                        unitCode: 'DAY',
                    },
                    transitTime: {
                        '@type': 'QuantitativeValue',
                        minValue: 1,
                        maxValue: 3,
                        unitCode: 'DAY',
                    },
                },
            },
        };
    }
    return {
        shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
                '@type': 'MonetaryAmount',
                value: 0,
                currency: 'USD',
            },
            shippingDestination: {
                '@type': 'DefinedRegion',
                addressCountry: 'US',
            },
        },
    };
};
exports.getShippingDetailsSchema = getShippingDetailsSchema;
//# sourceMappingURL=shipping-details-schema.js.map